import { store } from '@/state/store';
import { Provider } from 'react-redux';
import { APP__initializer } from './APP__initializer';

export function PROVIDER__store_redux() {
  return (
    <Provider {...{ store }}>
      <APP__initializer />
    </Provider>
  );
}
